import styled from 'styled-components';
import { darken } from 'polished';

export interface ButtonProps {
  textColor: string;
  backgroundColor: string;
  width?: string;
}

export const Container = styled.button<ButtonProps>`
  width: ${(props) => props.width || '100%'};
  min-height: 35px;
  max-height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  gap: 5px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  font-size: 12px;
  white-space: nowrap;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ textColor }) => textColor};
  transition: 0.2s;

  &:hover {
    background-color: ${({ backgroundColor }) => darken(0.1, backgroundColor)};
  }
`;
